export default __webpack_public_path__ + "static/media/IncredibleAnimalsSpeeders_01.6568ec54.png";